import React from "react";
import { Button, Modal } from "react-bootstrap";
import { gql, useMutation } from "@apollo/client";

function DeletePlantModal({ show, handleClose, plantData, onSuccess }) {
  const DELETE_PLANT_MUTATION = gql`
    mutation DeleteOnePlant($where: PlantWhereUniqueInput!) {
      deleteOnePlant(where: $where) {
        id
        name
      }
    }
  `;
  const [deletePlant, { loading }] = useMutation(DELETE_PLANT_MUTATION);

  const handleDelete = async () => {
    try {
      await deletePlant({
        variables: {
          where: { id: plantData.id },
        },
      });
      if (onSuccess) onSuccess();
      handleClose();
    } catch (err) {
      console.error("Delete failed", err);
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        size="sm"
        centered
      >
        <Modal.Header className="d-flex align-items-center justify-content-between">
          <Modal.Title>Delete Confirmation?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            Are you sure you want to delete the plant. Once done, the
            information can not be retrieved.
            <div className="border rounded p-2 mt-3">
              <div>Plant Name</div>
              <div className="font-weight-bold">{plantData?.name}</div>
            </div>
            <div className="border rounded p-2 mt-3">
              <div>Total Zones</div>
              <div className="font-weight-bold">
                {plantData?.zones?.length || 0}
              </div>
            </div>
            <div className="border rounded p-2 mt-3">
              <div>Total Shifts</div>
              <div className="font-weight-bold">
                {plantData?.shifts?.length || 0}
              </div>
            </div>
            <b>
              Note: This action will delete the plant and all associated data.
            </b>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex align-items-center justify-content-between">
          <Button variant="danger" onClick={handleDelete} disabled={loading}>
            {loading ? "Deleting..." : "Yes, delete"}
          </Button>
          <Button variant="outline-danger" onClick={handleClose}>
            Go Back
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default DeletePlantModal;
